import api from '@/api'

const namespaced = true

const state = {
  cargoStolen: [],
  vesselCargoStolen: [],
  cargoStolenFiles: {},
  detailCargoStolen: null,
  attachments: [],
  percentageCargoStolenChart: null,
  summaryCargoStolen: null
}

const getters = {
  cargoStolen: state => state.cargoStolen,
  vesselCargoStolen: state => state.vesselCargoStolen,
  cargoStolenFiles: state => state.cargoStolenFiles,
  detailCargoStolen: state => state.detailCargoStolen,
  attachments: state => state.attachments,
  percentageCargoStolenChart: state => state.percentageCargoStolenChart,
  summaryCargoStolen: state => state.summaryCargoStolen
}

const mutations = {
  SET_CARGO_STOLLEN: (state, payload) => {
    state.cargoStolen = payload
  },
  SET_VESSEL_CARGO_STOLLEN: (state, payload) => {
    state.vesselCargoStolen = payload
  },
  SET_CARGO_STOLLEN_FILES: (state, payload) => {
    state.cargoStolenFiles = payload
  },
  SET_DETAIL_CARGO_STOLLEN: (state, payload) => {
    state.detailCargoStolen = payload
  },
  SET_ATTACHMENTS: (state, payload) => {
    state.attachments = payload
  },
  SET_PERCENTAGE_CARGO_STOLLEN_CHART: (state, payload) => {
    state.percentageCargoStolenChart = payload
  },
  SET_SUMMARY_CARGO_STOLLEN: (state, payload) => {
    state.summaryCargoStolen = payload
  }
}

const actions = {
  async fetchCargoStolen({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']

      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload,
        ...(!!payload?.sort_dir && { sort_dir: payload.sort_dir.toUpperCase() })
      }

      const { data } = await api.getCargoStolen(filter)
      if (data.error) {
        commit('SET_CARGO_STOLLEN', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_CARGO_STOLLEN', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async fetchDetailCargoStolen({ commit }, payload) {
    try {
      const { data } = await api.getCargoStolenById(payload)
      if (data.error) {
        commit('SET_DETAIL_CARGO_STOLLEN', null)
        return
      }

      commit('SET_DETAIL_CARGO_STOLLEN', data)
    } catch (err) {
      throw err
    }
  },
  async postCargoStolenFiles({ commit }, payload) {
    try {
      const formData = new FormData()
      if (Array.isArray(payload)) {
        payload.forEach(file => {
          formData.append('files', file)
        })
      } else {
        formData.append('files', payload)
      }

      const { data } = await api.postCargoStolenFiles(formData)
      if (data.error) {
        commit('SET_ATTACHMENTS', [])
        return []
      }

      const attachments = data.data || data
      commit('SET_ATTACHMENTS', Array.isArray(attachments) ? attachments : [attachments])
      return Array.isArray(attachments) ? attachments : [attachments]
    } catch (err) {
      throw err
    }
  },
  async putCargoStolen(_, payload) {
    try {
      await api.putCargoStolen(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async postCargoStolenSendEmail({ commit }, payload) {
    try {
      const { data } = await api.postCargoStolenSendEmail(payload)
      if (data.error) {
        return
      }
      return data.data
    } catch (error) {
      throw error
    }
  },
  async fetchVesselCargoStolen({ commit }, payload) {
    try {
      const { data } = await api.getVesselCargoStolen(payload)
      if (data.error) {
        commit('SET_VESSEL_CARGO_STOLLEN', [])
        return
      }

      commit('SET_VESSEL_CARGO_STOLLEN', data)
    } catch (err) {
      throw err
    }
  },
  async fetchPercentageCargoStolenChart({ commit }, payload) {
    try {
      const { data } = await api.getPercentageCargoStolenChart(payload)
      if (data.error) {
        commit('SET_PERCENTAGE_CARGO_STOLLEN_CHART', null)
        return
      }
      commit('SET_PERCENTAGE_CARGO_STOLLEN_CHART', data)
      return data
    } catch (err) {
      throw err
    }
  },
  async fetchSummaryCargoStolen({ commit }, payload) {
    try {
      const { data } = await api.getSummaryCargoStolen(payload)
      if (data.error) {
        commit('SET_SUMMARY_CARGO_STOLLEN', null)
        return
      }
      commit('SET_SUMMARY_CARGO_STOLLEN', data)
    } catch (err) {
      throw err
    }
  },
  async exportCargoStolen({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const data = await api.getCargoStolenExport({
        search: filterConfig.search,
        ...payload})
      if (data) {
        commit('SET_CARGO_STOLLEN_FILES', data)
      }
    } catch (error) {
      throw error.data;
    }
  },
  resetFileExport({ commit }) {
    commit('SET_CARGO_STOLLEN_FILES', {})
  }
}

export default { namespaced, state, getters, mutations, actions }